import Config from "./Config";

export const endpoints = {
  login: `${Config.apiUrl}/auth/login`,
  logout: `${Config.apiUrl}/auth/signout`,
  ordersEndpoint: `${Config.apiUrl}/order`,
  getProductsSearch: `${Config.apiUrl}/product/search`,
  orderOfferEndpoint: `${Config.apiUrl}/orderOffer`,
  getPublicProductsSearch: `${Config.apiUrl}/orderOffer/searchProducts`,
  getPublicPaymentMethods: `${Config.apiUrl}/orderOffer/paymentMethods`,
  getOrderOfferForClient: `${Config.apiUrl}/orderOffer/order`,
  getPublicTransportOptions: `${Config.apiUrl}/orderOffer/transportOptions`,
  updateClientToAutomata: `${Config.apiUrl}/order/change-to-automatic-category`,
  rolesEndpoint: `${Config.apiUrl}/role`,
  orderStatus: `${Config.apiUrl}/orderStatus`,
  getProducts: `${Config.apiUrl}/product`,
  syncWordPressData: `${Config.apiUrl}/product/sync`,
  syncWordPressDataOrders: `${Config.apiUrl}/order/sync`,
  emailTemplatesEndpoint: `${Config.apiUrl}/emailTemplate`,
  duplicateOrder: `${Config.apiUrl}/order/duplicate/`,
  contactEndpoint: `${Config.apiUrl}/contact`,
  getDashboardSummaryContacts: `${Config.apiUrl}/contact/dashboard`,
  getAvailableContacts: `${Config.apiUrl}/contact/available`,
  getTakenContacts: `${Config.apiUrl}/contact/taken`,
  associateAgentWithContact: `${Config.apiUrl}/contact/associateAgent`,
  updateOrderNotes: `${Config.apiUrl}/order/notes`,
  updateContactNotes: `${Config.apiUrl}/contact/notes`,
  transportOption: `${Config.apiUrl}/transportOption`,
  classesEndPoint: `${Config.apiUrl}/classes`,
  whatsAppMetaUrl: "https://graph.facebook.com/v19.0/",
  clientsOrderHistory: `${Config.apiUrl}/order/clientOrderHistory`,
  orderAudits: `${Config.apiUrl}/order/audits`,
  recommendations: `${Config.apiUrl}/recommendations`,
  document: `${Config.apiUrl}/document`,
  hours: {
    main: `${Config.apiUrl}/hours`,
    orderHours: `${Config.apiUrl}/hours/orderHours`,
    supplimentaryHours: `${Config.apiUrl}/hours/supplimentaryHours`,
  },
  user: {
    main: `${Config.apiUrl}/user`,
    autocomplete: `${Config.apiUrl}/user/filter`,
    role: `${Config.apiUrl}/user/role`,
    expiredDocuments: `${Config.apiUrl}/user/expiredDocuments`,
  },
  media: {
    main: `${Config.apiUrl}/media`,
    delete: `${Config.apiUrl}/media/delete`,
    folder: `${Config.apiUrl}/media/folder`,
    public: `${Config.apiUrl}/media/public`,
  },
  clientCategory: {
    main: `${Config.apiUrl}/clientCategory`,
  },
  audit: {
    main: `${Config.apiUrl}/audit`,
  },
  oblio: {
    main: `${Config.apiUrl}/oblio`,
    syncProducts: `${Config.apiUrl}/oblio/syncProducts`,
    managementNomenclator: `${Config.apiUrl}/oblio/managementNomenclator`,
    cancel: `${Config.apiUrl}/oblio/cancel`,
  },
  whatsApp: {
    main: `${Config.apiUrl}/whatsApp`,
    waba: `${Config.apiUrl}/whatsApp/waba`,
    createPhoneNumber: `${Config.apiUrl}/whatsApp/createPhoneNumber`,
    registerPhoneNumber: `${Config.apiUrl}/whatsApp/registerPhoneNumber`,
    template: `${Config.apiUrl}/whatsApp/template`,
    uploadMedia: `${Config.apiUrl}/whatsApp/uploadMediaContentForHeader`,
    message: `${Config.apiUrl}/whatsApp/message`,
    templateMessage: `${Config.apiUrl}/whatsApp/templateMessage`,
    image: `${Config.apiUrl}/whatsApp/image`,
    sendFileMessage: `${Config.apiUrl}/whatsApp/sendFileMessage`,
  },
  conversation: {
    main: `${Config.apiUrl}/conversation`,
    markConversationAsRead: `${Config.apiUrl}/conversation/markConversationAsRead`,
    unreadConversations: `${Config.apiUrl}/conversation/unreadConversations`,
    associate: `${Config.apiUrl}/conversation/associate`,
  },
  setting: {
    main: `${Config.apiUrl}/setting/`,
    orderSettings: `${Config.apiUrl}/setting/orderSettings/`,
    orderSettingsNumber: `${Config.apiUrl}/setting/orderSettingsNumber/`,
    contact: `${Config.apiUrl}/setting/contactSettings/`,
    clients: `${Config.apiUrl}/setting/clientsSettings/`,
    updateClientsSettings: `${Config.apiUrl}/setting/clients/`,
    legal: `${Config.apiUrl}/setting/legal/settings/`,
    rules: `${Config.apiUrl}/setting/rules/settings/`,
    examQuestions: `${Config.apiUrl}/setting/examQuestion/settings/`,
    ocrToken: `${Config.apiUrl}/setting/ocrToken/settings/`,
  },
  subscriptions: {
    main: `${Config.apiUrl}/subscriptions`,
  },
  documentation: {
    main: `${Config.apiUrl}/documentation`,
  },
  client: {
    main: `${Config.apiUrl}/client`,
    search: `${Config.apiUrl}/client/search/`,
    periodicityNames: `${Config.apiUrl}/client/periodicityNames`,
    import: `${Config.apiUrl}/client/import`,
    getANAFData: `${Config.apiUrl}/client/anaf`,
    generateUserAccount: `${Config.apiUrl}/client/generateUserAccount`,
    getClientDocuments: `${Config.apiUrl}/client/documents/:clientId/order/:orderId`,
  },
  task: {
    main: `${Config.apiUrl}/task`,
    duplicate: `${Config.apiUrl}/task/duplicate`,
    subtask: `${Config.apiUrl}/task/subtask`,
  },
  alert: {
    main: `${Config.apiUrl}/alert`,
  },
  alertPerEntity: {
    main: `${Config.apiUrl}/alertPerEntity`,
  },
  notifications: {
    main: `${Config.apiUrl}/notifications`,
    markAsRead: `${Config.apiUrl}/notifications/markAsRead`,
    sendDrivingLesson: `${Config.apiUrl}/notifications/send-driving-lesson`,
    configurations: `${Config.apiUrl}/notification-configurations`,
    sendSMSMessages: `${Config.apiUrl}/notifications/send/sms/messages`,
    sendSMSFiltered: `${Config.apiUrl}/notifications/send/sms/filtered`,
  },
  workPoints: {
    main: `${Config.apiUrl}/workPoints`,
  },
  company: {
    main: `${Config.apiUrl}/company`,
  },
  vehicle: {
    main: `${Config.apiUrl}/vehicle`,
    expiredDocuments: `${Config.apiUrl}/vehicle/expiredDocuments`,
  },
  instructor: {
    main: `${Config.apiUrl}/instructor`,
    user: `${Config.apiUrl}/user/instructor`,
    byUser: `${Config.apiUrl}/instructor/by-user`,
    byWorkPoint: `${Config.apiUrl}/user/workpoint`,
  },
  product: {
    main: `${Config.apiUrl}/product`,
  },
  payments: {
    main: `${Config.apiUrl}/payments`,
    forOrder: `${Config.apiUrl}/payments/forOrder`,
    forInstructor: `${Config.apiUrl}/payments/forInstructor`,
  },
  exams: {
    main: `${Config.apiUrl}/exams`,
    forOrder: `${Config.apiUrl}/exams/forOrder`,
    verifySchedule: `${Config.apiUrl}/exams/verify-schedule`,
    certificateExams: `${Config.apiUrl}/certificate-exams`,
    certificateExamYears: `${Config.apiUrl}/certificate-exams/years`,
    changeCertificateExamDate: `${Config.apiUrl}/certificate-exams/changeDate`,
    certificateExamsForClient: `${Config.apiUrl}/certificate-exams/all/forClient/:clientId/order/:orderId`,
  },
  accounts: `${Config.apiUrl}/accounts`,
  reports: `${Config.apiUrl}/reports`,
  orderExpiration: `${Config.apiUrl}/order/expiring-categories`,
  courses: `${Config.apiUrl}/courses`,
  modules: `${Config.apiUrl}/modules`,
  examSets: `${Config.apiUrl}/examSets`,
  examQuestions: `${Config.apiUrl}/examQuestions`,
  books: `${Config.apiUrl}/books`,
  bookSales: `${Config.apiUrl}/book-sales`,
  onlineLessons: {
    main: `${Config.apiUrl}/online-lessons`,
    generateToken: `${Config.apiUrl}/video-call/token`,
  },
  smsSentReport: {
    list: `${Config.apiUrl}/reports/smsSent`,
  },
  documentTemplates: `${Config.apiUrl}/document-templates`,
  documentTypes: `${Config.apiUrl}/document-types`,
  generatedDocumentsForOrder: `${Config.apiUrl}/order/:id/generated-documents`,
  settings: {
    main: `${Config.apiUrl}/setting`,
    saveAll: `${Config.apiUrl}/setting/saveAll`,
  },
  drivingLicenseScan: `${Config.apiUrl}/ocr-service/driving-license/scan`,
  identityCardScan: `${Config.apiUrl}/ocr-service/identity-card/scan`,
};

export const localUrlEnum: any = {
  login: "/admin-panel/login",
  users: "/users?",
  workPoints: "/workPoints?",
  company: "/company?",
  clients: "/clients?",
  onlineClients: "/online-clients?",
  reports: "/reports",
  orders: "/orders?",
  settings: "/settings",
  messages: "/messages",
  orderStatus: "/orderStatus",
  order: "/orders/order",
  newOrder: "/order/new_order",
  client: "/clients/client",
  marketing: "/marketing",
  product: "/products/product",
  supportTickets: "/supportTickets",
  mainRoute: "/",
  tasks: "/tasks",
  dashboard: "/dashboard",
  whatsAppPhoneNumbers: "/whatsApp/phoneNumbers",
  whatsAppTemplates: "/whatsApp/templates",
  whatsAppTemplate: "/whatsApp/template",
  pageNotFound: "*",
  renderChildren: "",
  logs: "/logs",
  alerts: "/alerts",
  products: "/products?",
  contacts: "/contacts",
  emailTemplates: "/emailTemplates?",
  orderOfferPasswordCheck: "/orderOfferPasswordCheck",
  orderOffer: "/orderOffer",
  orderOfferConfirmation: "/orderOfferConfirmation",
  instructors: "/instructors",
  angajati: "/employees",
  vehicles: "/vehicles",
  services: "/services",
  classes: "/classes",
  classClients: "/classes/:classId/clients",
  recommendations: "/recommendations",
  cashDesk: "/cash-desk",
  accounts: "/accounts",
  scheduledExams: "/scheduledExams",
  scheduledExamsByType: "/scheduledExams/:type",
  drivingHoursInstructor: "/drivingHoursInstructor",
  documentValidity: "/documentValidity",
  psychologicalDocumentExpiration: "/psychologicalDocumentExpiration",
  reminderCategoryExpiration: "/categoryExpiration",
  reminderCarDocumentsExipiration: "/carDocumentsExpiration",
  reminderUserDocumentsExpiration: "/userDocumentsExpiration",
  courses: "/courses",
  modules: "/modules",
  examSets: "/examSets",
  examQuestions: "/examQuestions",
  books: "/books",
  scheduleDrivingHours: "/scheduleDrivingHours",
  drivingHoursCalendar: "/driving-hours-calendar",
  examsCalendar: "/exams-calendar",
  certificateExams: "/certificate-exams",
  documentTemplates: "/document-templates",
  subscriptions: "/subscriptions",
  register: "/register-test-apiS",
  notificationConfiguration: "/notification-configuration",
  smsClients: "/sms-clients",
  onlineLessons: "/online-lessons",
  onlineLessonRoom: "/online-lessons/:id",
  smsReport: "/sms-report",
};

export const basicOperationsEnum = {
  create: "/create",
  update: "/update",
  delete: "/delete",
  import: "/import",
  export: "/export",
};

export const pathParams = {
  optionalId: "/:id?",
  orderId: "/:orderId",
  page: "/:page",
  reportsType: "/:type",
};

export const foldersNames = {
  usersProfiles: "usersProfiles/",
};
